import * as React from "react";
import { cn } from "../../lib/utils";

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "default" | "primary" | "secondary";
  isDark?: boolean;
  showArrow?: boolean;
}

export function Button({
  className,
  variant = "default",
  isDark = true,
  showArrow = false,
  children,
  ...props
}: ButtonProps) {
  const baseClasses =
    "group relative font-medium transition-all duration-300 cursor-pointer pointer-events-auto hover:-translate-y-0.5 disabled:translate-y-0 disabled:opacity-50 disabled:cursor-not-allowed";

  const variantClasses = {
    default: "",
    primary: `w-full py-4 px-6 rounded-xl ${
      isDark
        ? "bg-white text-black hover:bg-zinc-200"
        : "bg-gray-900 text-white hover:bg-gray-800"
    }`,
    secondary: `w-full py-4 px-6 rounded-xl border ${
      isDark
        ? "bg-zinc-900 border-zinc-800 text-white hover:bg-zinc-800"
        : "border-gray-300 bg-white hover:bg-gray-100"
    }`,
  };

  return (
    <button
      className={cn(baseClasses, variantClasses[variant], className)}
      {...props}
    >
      <span className="flex items-center justify-center gap-2">
        {children}
        {showArrow && (
          <svg
            className="w-4 h-4 transition-transform group-hover:translate-x-0.5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M13 7l5 5m0 0l-5 5m5-5H6"
            />
          </svg>
        )}
      </span>
    </button>
  );
}

Button.displayName = "Button";
